import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { timeToMinutes, minutesToTime } from "@/lib/agenda-time";
import { AgendaAppointmentDialog, type DialogInitial } from "./AgendaAppointmentDialog";

/**
 * "Agendar consulta" de fora da Agenda (atalho do Início, "+" do celular): abre o diálogo de
 * criação hoje, no primeiro horário da agenda, com a duração padrão. `elementos` é o diálogo —
 * quem usa só renderiza.
 */
export function useNovaConsulta() {
  const utils = trpc.useUtils();
  const settingsQuery = trpc.settings.getAgenda.useQuery();
  const [initial, setInitial] = useState<DialogInitial | null>(null);

  function abrir() {
    const settings = settingsQuery.data;
    if (!settings) return;
    const startMin = timeToMinutes(settings.startHour);
    const endMin = Math.min(startMin + settings.defaultAppointmentDuration, timeToMinutes(settings.endHour));
    setInitial({ date: new Date(), startTime: settings.startHour, endTime: minutesToTime(endMin) });
  }

  const elementos =
    initial && settingsQuery.data ? (
      <AgendaAppointmentDialog
        open
        mode="create"
        initial={initial}
        settings={settingsQuery.data}
        onClose={() => setInitial(null)}
        onSaved={() => {
          setInitial(null);
          utils.appointment.listByRange.invalidate();
        }}
      />
    ) : null;

  return { abrir, pronto: !!settingsQuery.data, elementos };
}
